import { Box, Typography, Button, useTheme, useMediaQuery, SxProps, Theme } from "@mui/material";
import iconDownload from "@assets/img/icon_donwload.svg";

interface ButtonDownloadTablaAmortizacionProps {
  sx?: SxProps<Theme>;
  disabled: boolean;
  onClick: () => void;
}

const ButtonDownloadTablaAmortizacion = ({ sx, disabled, onClick }: ButtonDownloadTablaAmortizacionProps) => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box display="flex" flexDirection="column" alignItems="center" sx={sx}>
      <Button variant="text" href="#" onClick={onClick} disabled={disabled}>
        <Typography variant={isMobileOrTablet ? "body2" : "body1"} color={theme?.palette?.primary?.dark} align="center">
          <img src={iconDownload} /> Descarga aquí tu tabla de amortización
        </Typography>
      </Button>
    </Box>
  );
};

export default ButtonDownloadTablaAmortizacion;
